"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ProductListingPage = void 0;
var _mui = require("@ori-ui/mui");
var _editorialComponents = require("@ori/editorial-components");
var _editorialPage = require("@ori/editorial-page");
var _logger = require("@ori/logger");
var _olapicLib = require("@ori/olapic-lib");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _components = require("../../components");
var _utils = require("../../components/BannerProductListing/utils");
var _contexts = require("../../contexts");
var _useTranslations = require("../../hooks/useTranslations");
var _utils2 = require("../../utils");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Used to render product listing page
 *
 * @param breadcrumbs
 * @param data
 * @param olapicConfiguration
 * @param pageId
 * @constructor
 */ const ProductListingPage = (param)=>{
    let { data, pageId, hasFilters } = param;
    var _data_application_editorialPage, _data_application;
    const { getTestId } = (0, _testidGenerator.default)();
    const logger = (0, _logger.useLogger)('ProductListingPage');
    const { translations } = (0, _useTranslations.useTranslations)();
    const { productBoxConfiguration } = (0, _contexts.useProductListingContext)();
    const { getFacets } = (0, _utils.useGetProductListingFacets)({
        pageId
    });
    const { getProductListingData } = (0, _utils.useGetProductListingData)({
        pageId
    });
    if (!(data === null || data === void 0 ? void 0 : (_data_application = data.application) === null || _data_application === void 0 ? void 0 : (_data_application_editorialPage = _data_application.editorialPage) === null || _data_application_editorialPage === void 0 ? void 0 : _data_application_editorialPage.contentItems)) {
        logger.warn(_constants.NO_CONTENT_ITEMS_FOUND_MESSAGE);
        return null;
    }
    const { contentItems } = data.application.editorialPage;
    const pageLayout = contentItems.map((item, modulePosition)=>{
        switch(item.__typename){
            case 'EditorialHeader':
                var _data_application, _data_application1;
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.HeaderArea, {
                    breadcrumbs: (_data_application = data.application) === null || _data_application === void 0 ? void 0 : _data_application.breadcrumbLinks,
                    banner: item,
                    pageNavigation: (_data_application1 = data.application) === null || _data_application1 === void 0 ? void 0 : _data_application1.pageNavigation
                });
            case 'EditorialPlpRows':
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_contexts.BannerProductListingProvider, {
                    isPLP: true,
                    pageId: pageId,
                    data: item.content,
                    getFacets: getFacets,
                    getData: getProductListingData,
                    hasFilters: hasFilters,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.BannerProductListing, {})
                });
            case 'EditorialBanner':
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.EditorialRoot, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.EditorialBannersRoot, {
                        children: (0, _editorialPage.createBannerLayout)({
                            banner: item,
                            debug: false,
                            modulePosition
                        })
                    })
                });
            case 'EditorialProductBoxCarousel':
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.CarouselRoot, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.CarouselInner, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.StyledProducts, {
                            debug: false,
                            modulePosition: modulePosition,
                            hideRating: !productBoxConfiguration.isRatingsAndReviewsEnabled,
                            mrpStatementEnabled: productBoxConfiguration.isMrpStatementEnabled,
                            headline: item.headline,
                            productCodes: (0, _utils2.getProductCodes)(item.products)
                        })
                    })
                });
            case 'EditorialOlapic':
                var _item_product;
                var _item_type, _item_categoryId;
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.NoSsr, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.StyledOlapicWidget, {
                        type: (_item_type = item.type) !== null && _item_type !== void 0 ? _item_type : _olapicLib.OlapicTypeEnum.FrontPage,
                        categoryId: (_item_categoryId = item.categoryId) !== null && _item_categoryId !== void 0 ? _item_categoryId : undefined,
                        productCode: (_item_product = item.product) === null || _item_product === void 0 ? void 0 : _item_product.productCode
                    })
                });
            case 'EditorialCarousel':
                {
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.CarouselRoot, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.EditorialCarouselSectionRoot, {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_editorialComponents.EditorialCarouselSection, {
                                data: (0, _editorialComponents.mapEditorialCarousel)({
                                    slides: item.editorials
                                }),
                                labelRead: translations.readNow,
                                title: translations.inspirationCorner,
                                id: "plp-related-articles-carousel-".concat(modulePosition)
                            })
                        })
                    });
                }
            default:
                logger.warn((0, _constants.unknownTypeMessage)(item.__typename));
                return null;
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Root, {
        "data-testid": getTestId(_constants.PRODUCT_LISTING_PAGE),
        children: pageLayout
    });
};
exports.ProductListingPage = ProductListingPage;
